import path from 'ramda/src/path'

import moduleDescriptions from 'root/src/shared/descriptions/modules'
import moduleIdFromKey from 'root/src/client/logic/route/util/moduleIdFromKey'

export default (state, props) => {
	const { moduleKey, fieldDescPath } = props
	const fieldData = path(
		[moduleIdFromKey(moduleKey), ...fieldDescPath],
		moduleDescriptions,
	)
	return typeof fieldData === 'function' ? fieldData(state, props).label : fieldData.label
}
